var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C4.60818 0.00185206 3.2739 0.55557 2.28974 1.53974C1.30557 2.5239 0.751852 3.85818 0.75 5.25C0.75 9.01906 5.64125 13.7397 5.84906 13.9388C5.88948 13.978 5.94363 14 6 14C6.05637 14 6.11052 13.978 6.15094 13.9388C6.35875 13.7397 11.25 9.01906 11.25 5.25C11.2481 3.85818 10.6944 2.5239 9.71027 1.53974C8.7261 0.55557 7.39182 0.00185206 6 0ZM6 7.65625C5.52409 7.65625 5.05887 7.51513 4.66316 7.25072C4.26745 6.98632 3.95904 6.61052 3.77692 6.17083C3.59479 5.73115 3.54714 5.24733 3.63999 4.78056C3.73283 4.3138 3.962 3.88504 4.29852 3.54852C4.63504 3.212 5.0638 2.98283 5.53056 2.88999C5.99733 2.79714 6.48115 2.84479 6.92083 3.02691C7.36052 3.20904 7.73632 3.51745 8.00072 3.91316C8.26513 4.30887 8.40625 4.77409 8.40625 5.25C8.40584 5.88805 8.1522 6.49986 7.70103 6.95103C7.24986 7.4022 6.63805 7.65584 6 7.65625Z",
    fill: "#121212",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOn);
export default __webpack_public_path__ + "static/media/LocationOn.80cd6443694a665374baa41f54cb028a.svg";
export { ForwardRef as ReactComponent };